import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterCustomersElementsEatenList'
})
export class FilterPipeCustomerElementsEaten implements PipeTransform {
  transform(elements: any, term?: any): any {
    if (term === undefined) return elements;
    if (term === null) return elements;

    if (elements != null) {
      return elements.filter(function (element) {
        if (element.name != undefined)
          if (element.name.toLowerCase().includes(term.toLowerCase()))
            return element;
        if (element.units != undefined)
          if (element.units.toString().toLowerCase().includes(term.toLowerCase()))
            return element;
        if (element.price != undefined)
          if (element.price.toString().toLowerCase().includes(term.toLowerCase()))
            return element;
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/customers/customers-elements-list/filter.pipe.ts